import React from "react";

const PrivacyPolicy = () => (
  <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-md my-10">
    <h1 className="text-3xl font-bold mb-4 text-center">Privacy Policy</h1>
    <p className="text-sm text-gray-500 mb-8 text-center">
      Last Updated: 15/5/2025
    </p>

    <section className="space-y-6">
      <p>
        Roots ("we", "our", or "us") respects your privacy and is committed to
        protecting the personal information you provide through our online
        ordering portal (“the Portal”). This Privacy Policy explains how we
        collect, use, and protect your data.
      </p>

      <div>
        <h2 className="text-xl font-semibold mb-2">1. Who We Are</h2>
        <ul className="list-disc list-inside">
          <li>
            <strong>Company Name:</strong> Roots
          </li>
          <li>
            <strong>Country of Incorporation:</strong> Jordan
          </li>
          <li>
            <strong>Contact Email:</strong>{" "}
            <a
              href="mailto:admin@roots-jo.co"
              className="text-blue-600 underline"
            >
              admin@roots-jo.co
            </a>
          </li>
        </ul>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">2. Scope</h2>
        <p>
          This Privacy Policy applies to all users of the Portal, including:
        </p>
        <ul className="list-disc list-inside ml-4">
          <li>Merchants</li>
          <li>Delivery personnel</li>
          <li>Operators</li>
          <li>Accountants</li>
          <li>Admins</li>
        </ul>
        <p className="mt-2">
          Roots is a B2B platform and does not serve individual consumers.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">
          3. Information We Collect
        </h2>
        <ul className="list-disc list-inside">
          <li>Full name</li>
          <li>Business information</li>
          <li>Phone number</li>
          <li>Secondary phone number</li>
          <li>Physical location</li>
          <li>Business address</li>
        </ul>
        <p className="mt-2">
          We do not collect credit card or banking information.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">
          4. How We Use Your Information
        </h2>
        <ul className="list-disc list-inside">
          <li>To manage and operate the online ordering system</li>
          <li>To assign and fulfill delivery requests</li>
          <li>To maintain user access and permissions</li>
          <li>To send notifications (via Firebase)</li>
          <li>To map delivery locations (via Google Maps)</li>
        </ul>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">5. Third-Party Services</h2>
        <p>We do not share your data with third parties. We use:</p>
        <ul className="list-disc list-inside">
          <li>
            <strong>Firebase</strong> – for push notifications
          </li>
          <li>
            <strong>Google Maps</strong> – for geolocation and address mapping
          </li>
        </ul>
        <p className="mt-2">
          These services may collect technical data under their own policies.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">
          6. Authentication and Tracking
        </h2>
        <p>
          We use JWT (JSON Web Tokens) for authentication. No cookies or
          browser-based tracking is used.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">7. Data Security</h2>
        <ul className="list-disc list-inside">
          <li>HTTPS for secure communication</li>
          <li>Encrypted data storage</li>
          <li>Role-based access controls</li>
        </ul>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">8. Data Retention</h2>
        <p>
          User data is retained indefinitely unless removed by system
          administrators. Self-service deletion is not currently supported.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">9. User Rights</h2>
        <p>
          Although not governed by GDPR or CCPA, we follow reasonable privacy
          practices and operate under Jordanian law.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">10. Children’s Privacy</h2>
        <p>
          This platform is for business users only and is not directed toward
          minors or individuals.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">
          11. International Data Transfers
        </h2>
        <p>
          All data is stored with DigitalOcean in accordance with their hosting
          policies. No data is transferred outside Jordan.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">
          12. Changes to This Policy
        </h2>
        <p>
          We may update this Privacy Policy periodically. Changes will be
          communicated via the platform or email.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">13. Contact Us</h2>
        <p>
          If you have questions or concerns, contact us at:{" "}
          <a
            href="mailto:admin@roots-jo.co"
            className="text-blue-600 underline"
          >
            admin@roots-jo.co
          </a>
        </p>
      </div>
    </section>
  </div>
);

export default PrivacyPolicy;
